/* RESPONSIBLE TEAM: team-ai-agent */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
export default class ProfileSerializer extends EmbercomBaseSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    genericTriageLocalizations: { embedded: 'always' },
  };
}
